const SUGGESTED_AVAILABILITY = "/webservice/suggested_availability";
const SET_APPOINTMENT_TIME = "/webservice/set_appointment_time";

module.exports = {
    getSuggestedAvailability: function getSuggestedAvailability(booking_id, customer_id) {
        return window.axios.get(SUGGESTED_AVAILABILITY, {
            params: {booking_id: booking_id, customer_id: customer_id}
        });
    },
    setAppointmentTime: function getSuggestedAvailability(fieldworkers, from, to, booking_id, customerId, companyId) {
        return window.axios.get(SET_APPOINTMENT_TIME, {
            params: {
                fieldworkers: fieldworkers,
                start_time: from.format('YYYY-MM-DD HH:mm'),
                end_time: to.format('YYYY-MM-DD HH:mm'),
                booking_id: booking_id,
                customer_id: customerId,
                company_id: companyId
            }
        });
    }
};